var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 14H1.8c-.662 0-1.2-.523-1.2-1.167V2.917H0V1.75h3.6V.875A.89.89 0 014.5 0h3c.495 0 .9.391.9.875v.875H12v1.167h-.6v9.916c0 .644-.538 1.167-1.2 1.167zm0-11.083H1.8v9.625c0 .16.134.291.3.291h7.8c.166 0 .3-.13.3-.291V2.917zM4.8 5.25a.592.592 0 00-.6-.583c-.331 0-.6.261-.6.583v5.25c0 .322.269.583.6.583.331 0 .6-.261.6-.583V5.25zm3.6 0a.592.592 0 00-.6-.583c-.331 0-.6.261-.6.583v5.25c0 .322.269.583.6.583.331 0 .6-.261.6-.583V5.25zM7.2 1.167H4.8v.583h2.4v-.583z",
    fill: "#292929",
    fillRule: "evenodd"
  })));
}
export default SvgIconTrash;